'use client';

import { Box, Typography } from '@mui/material';

import { NavLink } from '@/components';

interface NavigationItem {
  to: string;
  label: string;
}

interface DesktopNavigationProps {
  items: NavigationItem[];
}

interface NavItemContentProps {
  isActive: boolean;
  label: string;
}

const NavItemContent = ({ isActive, label }: NavItemContentProps) => {
  return (
    <Typography
      variant="body2"
      suppressHydrationWarning
      sx={{
        px: { md: 1.25, lg: 1.5 },
        py: 1,
        borderRadius: 1,
        fontWeight: isActive ? 600 : 500,
        fontSize: { md: '0.9rem', lg: '0.95rem' },
        color: isActive ? 'primary.main' : 'text.secondary',
        transition: 'all 0.2s ease',
        whiteSpace: 'nowrap',
        '&:hover': {
          color: 'primary.main',
        },
      }}
    >
      {label}
    </Typography>
  );
};

export const DesktopNavigation = ({ items }: DesktopNavigationProps) => {
  return (
    <Box
      component="nav"
      aria-label="Main navigation"
      sx={{
        display: { xs: 'none', lg: 'inline-flex' },
        alignItems: 'center',
        gap: { md: 0.5, lg: 0.75 },
      }}
    >
      {items.map((navigationItem) => (
        <NavLink key={navigationItem.to} to={navigationItem.to} style={{ textDecoration: 'none' }}>
          {({ isActive }) => <NavItemContent isActive={isActive} label={navigationItem.label} />}
        </NavLink>
      ))}
    </Box>
  );
};
